<script setup lang="ts">
/**
 * Navbar — odwzorowanie navbar.html z Django.
 * Logo "Nhex", menu: Armies, Settings/Login/Register.
 * Brak linku Admin w navbar (admin dostępny przez avatar w footer).
 */
import { useAuthStore } from '@/stores/auth'

const auth = useAuthStore()
</script>

<template>
  <nav class="p-2 w-full pt-1 menu">
    <div class="flex items-center justify-between" style="flex-wrap: nowrap;">
      <!-- Logo + breadcrumbs -->
      <div class="flex items-center flex-shrink-0 mr-4" style="white-space: nowrap;">
        <RouterLink
          to="/"
          class="no-underline hover:no-underline px-2 rounded-sm"
        >
          <span
            class="nhex1"
            data-n="Nhex"
            title="Upload fan armies! Test with friends wherever they are! Share them with the whole world!"
          >Nhex</span>
        </RouterLink>
        <div id="nav-breadcrumbs" class="navBtn" style="display: inline-flex; align-items: center; margin-left: 10px; flex-shrink: 0;">
          <slot />
        </div>
      </div>

      <!-- Menu -->
      <ul class="py-0 flex justify-start items-center text-gray-200 list-none m-0 p-0" style="flex-wrap: nowrap; flex-shrink: 0;">
        <li>
          <RouterLink
            to="/armies"
            class="nhex2 no-underline"
            data-n="Armies"
            title="Upload your Neuroshima Hex army!"
          >Armies</RouterLink>
        </li>
        <template v-if="auth.isAuthenticated">
          <li>
            <RouterLink
              to="/settings"
              class="nhex2 nhex2l no-underline"
              data-n="Settings"
            >Settings</RouterLink>
          </li>
        </template>
        <template v-else>
          <li>
            <RouterLink
              to="/login"
              class="nhex2 nhex2l no-underline"
              data-n="Login"
            >Login</RouterLink>
          </li>
          <li>
            <RouterLink
              to="/register"
              class="nhex2 nhex2l no-underline"
              data-n="Register"
            >Register</RouterLink>
          </li>
        </template>
      </ul>
    </div>
  </nav>
</template>
